function fn_part_ui_select() {
    $(".part_ui_select").find("select").on("click",function() {
        $(this).parent().toggleClass("mod--focus");
        $(this).one("blur",function() {
            $(this).parent().removeClass("mod--focus");
        });
    });
}